var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{attrs:{"bottom":100}},[_c('div',{staticClass:"backtop-content"},[_c('img',{attrs:{"src":require("@/assets/images/scroll-top.png"),"alt":""}}),_c('div',[_vm._v("回到顶部")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }